import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {environment as env} from "src/environments/environment";
import {Ocorrencia} from "../domain/Ocorrencia";
import {Observable} from "rxjs";
import {OcorrenciaHistorico, OcorrenciaHistoricoDTO} from "../domain/OcorrenciaHistorico";

@Injectable()
export class OcorrenciaService {

  constructor(private http: HttpClient) { }

  httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };

  getOcorrencias(idGestaoInterface: number){
    let url =`${env.apiUrlBase}/ocorrencia/v1/interface`;
    url= url.concat(`?idGestaoInterface=${idGestaoInterface}`)
    return this.http.get<Ocorrencia>(url)
      .toPromise()
      .then(res => res as Ocorrencia)
      .then(data => data);
  }
  getOcorrenciasDB2(idGestaoInterface: number){
    let url =`${env.apiUrlBase}/ocorrencia/v1/interface/erros`;
    url= url.concat(`?idInterface=${idGestaoInterface}`)
    return this.http.get<Ocorrencia>(url)
      .toPromise()
      .then(res => res as Ocorrencia)
      .then(data => data);
  }
  postOcorrencia(ocorrencias: Ocorrencia): Observable<Ocorrencia>{
    return this.http.post<Ocorrencia>(`${env.apiUrlBase}/ocorrencia/v1/ocorrencia`,JSON.stringify(ocorrencias), this.httpOptions);
  }
  postOcorrenciaHistorico(ocorrencias: OcorrenciaHistoricoDTO): Observable<OcorrenciaHistoricoDTO>{
    return this.http.post<OcorrenciaHistoricoDTO>(`${env.apiUrlBase}/ocorrencia/v1/historico`,JSON.stringify(ocorrencias), this.httpOptions);
  }
  getHistoricoOcorrencias(idGestaoInterface: number){
    let url =`${env.apiUrlBase}/ocorrencia/v1/historico`;
    url=url.concat(`?id=${idGestaoInterface}`)
    return this.http.get<Ocorrencia>(url)
      .toPromise()
      .then(res => res as Ocorrencia)
      .then(data => data);
  }
}
